import { isPossiblePhoneNumber } from 'libphonenumber-js';
import { addMethod, string } from 'yup';

addMethod(string, 'phone', function (message) {
  return this.test('phone-test', message, (value) => isPossiblePhoneNumber(value ?? 'null'));
});
